import { useCallback, useState } from 'react';

import { IFastGame, IRematchStatus } from '../types/fast-game';

export function useRematch(
  game: IFastGame | undefined,
  playerSide: 'white' | 'black' | 'none',
): { rematchStatus: IRematchStatus; onRematch: () => void } {
  const [rematchRequested, setRematchRequested] = useState(false);
  const rematch = game?.rematch;
  const onRematch = useCallback(() => {
    setRematchRequested(true);
    rematch?.();
  }, [rematch]);

  const canRematch = game?.isFinished && playerSide !== 'none' && Boolean(game?.rematchExpiration);

  const isOpponentRematch = playerSide === 'white' ? game?.rematchBlack : game?.rematchWhite;

  const isPlayerRematch =
    rematchRequested || (playerSide === 'white' ? game?.rematchWhite : game?.rematchBlack);

  const rematchStatus: IRematchStatus = !canRematch
    ? 'none'
    : isPlayerRematch
      ? 'player'
      : isOpponentRematch
        ? 'opponent'
        : 'available';

  return { rematchStatus, onRematch };
}
